import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Checkbox, Typography } from "@mui/material";
import SearchBar from "../../components/search/Search";
import Table, {
  type TableColumn,
} from "../../components/CommonTable/CommonTable";
import InfoCard from "../../components/InfoCard/InfoCard";

interface StudyMaterial {
  subject: string;
  classGroup: string;
  fileType: string;
  lastUploadDate: string;
  addCart?: boolean;
  [key: string]: unknown;
}

const StudyMaterialSubTopic = () => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const [materials, setMaterials] = useState<StudyMaterial[]>([
    {
      subject: "English",
      classGroup: "Class 5th",
      totalMaterial: 8,
      fileType: "PDF",
      lastUploadDate: "Today",
      addCart: false,
      requestQty: 1,
    },
    {
      subject: "Mathematics",
      classGroup: "Class 5th",
      totalMaterial: 12,
      fileType: "PDF",
      lastUploadDate: "20-07-2025",
      addCart: true,
      requestQty: 2,
    },
    {
      subject: "General Knowledge",
      classGroup: "Class 5th",
      totalMaterial: 8,
      fileType: "PDF",
      lastUploadDate: "23-07-2025",
      addCart: false,
      requestQty: 1,
    },
  ]);

  const handleCartToggle = (index: number) => {
    setMaterials((prev) =>
      prev.map((m, i) => (i === index ? { ...m, addCart: !m.addCart } : m))
    );
  };
  const handleSearchSubmit = () => {
    console.log("Search submitted:", searchValue);
  };

  const columns: TableColumn<StudyMaterial>[] = [
    { key: "subject", title: "Subject", sortable: true },
    { key: "classGroup", title: "Class/Group", sortable: true },
    {
      key: "totalMaterial",
      title: "Total Material",
      sortable: true,
      align: "center",
    },
    { key: "fileType", title: "File Type", align: "center" },
    { key: "lastUploadDate", title: "Last Upload Date", sortable: true },
    {
      key: "addCart",
      title: "Add Cart",
      align: "center",
      render: (value, _, index) => (
        <Checkbox
          checked={Boolean(value)}
          onChange={() => handleCartToggle(index)}
        />
      ),
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
      {/* <Box>
        <SearchBar
          value={searchValue}
          onChange={setSearchValue}
          placeholder="Search here..."
          onSubmit={handleSearchSubmit}
        />
      </Box> */}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          gap: "30px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <InfoCard title="Recent Uploads" subtitle="recent activity" />
        </Box>
        <Box sx={{ width: "100%" }}>
          <InfoCard title="Popular Notes" subtitle="recent activity" />
        </Box>
        <Box sx={{ width: "100%" }}>
          <InfoCard title="Exam Guides" subtitle="recent activity" />
        </Box>
      </Box>

      <Box>
        <Table<StudyMaterial> columns={columns} data={materials} />
      </Box>
      <Box>
        <Typography
          onClick={() => navigate("/study_materials/cart")}
          sx={{
            textAlign: "flex end",
          }}
        >
          Go to cart
        </Typography>
      </Box>
    </Box>
  );
};

export default StudyMaterialSubTopic;
